module.exports = __webpack_public_path__ + "img/avatar4.147b8908.png";